import { render, staticRenderFns } from "./BaseTopContentCard.vue?vue&type=template&id=0d732772&scoped=true"
import script from "./BaseTopContentCard.vue?vue&type=script&lang=js"
export * from "./BaseTopContentCard.vue?vue&type=script&lang=js"
import style0 from "./BaseTopContentCard.vue?vue&type=style&index=0&id=0d732772&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d732772",
  null
  
)

export default component.exports